import React from "react";
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-dates/lib/css/_datepicker.css'

import { Row } from 'components/Layout'
import LogItem from './LogItem'
import { alertIcon_tri as alertIcon } from 'img/icons'
import style from './_eventlog.module.scss'


export default class TrackerLogItem extends React.Component {

	dayBox = timestamp => <div className={style.daybox}>{moment(timestamp).format("dddd DD MMMM YYYY")}</div>;

	alertSignal = message => <div className={style.alert}>
		<div data-tip={message}>
			<img src={alertIcon} alt="alert" style={{width:"20px", height:"20px"}}/>
		</div>
		<ReactTooltip className={style.tooltip} effect='solid'/>
	</div>;

	infoBox = (name, value, mu) => <Row className={`${style.infobox} ${style.underlined}`}>
		{name && <div className={style.title}>{`${name}`}</div>}
		<div>{value}{mu && mu}</div>
	</Row>;

	render() {

		let {getIcon, item, pos, data, elements, onClick} = this.props;
		let packetLost=pos > 0 ? data[pos-1].seqNumber - item.seqNumber - 1 : null;

		return <LogItem
			item={item}
			pos={pos}
			getIcon={getIcon}
			onClick={onClick}
			showday={pos === 0 || moment(item.timestamp).format("YYYY-MM-DD") !== moment(elements[pos-1].timestamp).format("YYYY-MM-DD")}
			isLast={pos === data.length-1}>
					<Row>
						<div className={style.time}>ore {moment(item.timestamp).format("HH:mm")}</div>
						{
							item.gpsValid === 0 && this.alertSignal("Nessun dato GPS ricevuto")
						}
						{
							item.delay > 120 && this.alertSignal(`Messaggio ricevuto con ${moment.duration(item.delay, "seconds").humanize()} di ritardo`)
						}
						{
							packetLost && packetLost > 0 ?
								this.alertSignal(packetLost === 1 ? `è stato perso un messaggio` : `Sono stati persi ${packetLost} messaggi`)
								: null
						}
						{
							item.phState === 1 && this.alertSignal("Il dispositivo è stato aperto")
						}
					</Row>
					<Row>
						{item.temperature != null && this.infoBox("temperatura", item.temperature, "°")}
						{item.velocity != null && this.infoBox("velocità", item.velocity, "Km/h")}
						{item.errorDeviceResponse && this.infoBox(null, item.errorDeviceResponse.info, null) }
					</Row>
		</LogItem>
	}
}
